import { createFileRoute } from "@tanstack/react-router";

import { LibraryPage } from "@/features/library/library-page";
import { oneOf, optionalString } from "@/lib/search";
import { UPLOAD_MODE_PARAMS, type UploadModeParam } from "@/lib/upload-route";

export interface UploadRouteSearch {
  /** Preselects "Add to an existing machine" with this machine key. */
  machine?: string;
  /** `new` preselects "Always create a new machine". */
  mode?: UploadModeParam;
}

/**
 * Direct entry to the upload dialog (a reload or a pasted link). Normally the dialog is a
 * masked overlay of the screen underneath (`lib/upload-route.ts`); here it sits over the library.
 * Closing lands on the machine page when `?machine=` names one (`use-upload-dialog.ts`).
 */
export const Route = createFileRoute("/upload")({
  validateSearch: (raw: Record<string, unknown>): UploadRouteSearch => ({
    machine: optionalString(raw.machine),
    mode: oneOf(UPLOAD_MODE_PARAMS, raw.mode),
  }),
  component: UploadRoute,
});

function UploadRoute() {
  return <LibraryPage query="" />;
}
